import { USER_DATA } from "./types";

export const storeUserDetails = (data) => {
  return {
    type: USER_DATA,
    payload: data,
  };
};
